import { FilterState, PersonType } from 'models';

export const filterPeople = (
  allPeople: PersonType[],
  filter: FilterState | null,
  subfilters: FilterState[],
  activePersonId?: number
) =>
  allPeople.filter(
    (p) =>
      (!filter || !filter.value || p[filter.name] === filter.value) &&
      (!activePersonId || p.id !== activePersonId) &&
      subfilters.reduce<boolean>((acc, item) => acc && p[item.name] === item.value, true)
  );
